/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import PropTypes from 'prop-types';

export const Props = {
  data: PropTypes.object,
  fetchError: PropTypes.shape({
    data: PropTypes.object,
    message: PropTypes.string,
    stack: PropTypes.string,
    type: PropTypes.symbol
  }),
  isFetching: PropTypes.bool.isRequired,
  isFetchError: PropTypes.bool.isRequired,
  isFetchQueued: PropTypes.bool.isRequired,
  lastUpdated: PropTypes.number,
  redirectToBack: PropTypes.bool,
  redirectToUpdate: PropTypes.bool
};

export const Shape = PropTypes.shape(Props);
